import { render, staticRenderFns } from "./GoalTree.vue?vue&type=template&id=73617396&scoped=true&lang=pug&"
import script from "./GoalTree.vue?vue&type=script&lang=js&"
export * from "./GoalTree.vue?vue&type=script&lang=js&"
import style0 from "./GoalTree.vue?vue&type=style&index=0&id=73617396&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73617396",
  null
  
)

export default component.exports